/**
 * 新增餐饮 - 枚举与表单配置（与 aily/inde.js 对齐）
 * antd Select 格式：{ label: string, value: number }
 */
/** 餐饮店规模 */
export const RestaurantScaleEnum = [
  { label: "大", value: 1 },
  { label: "中", value: 2 },
  { label: "小", value: 3 },
];

/** 餐饮单位状态 */
export const RestaurantStatusEnum = [
  { label: "营业", value: 1 },
  { label: "待营业",value: 4},
  { label: "暂停营业", value: 2 },
  { label: "闭店/注销", value: 3 },
];

/** 餐饮店品类 */
export const RestaurantCategoryEnum = [
  { label: "小吃", value: 1 },
  { label: "火锅", value: 2 },
  { label: "烧烤", value: 3 },
  { label: "炒菜", value: 4 },
  { label: "快餐", value: 5 },
  { label: "面包甜点", value: 11 },
  { label: "学校餐厅", value: 6 },
  { label: "医院餐厅", value: 7 },
  { label: "机关餐厅", value: 8 },
  { label: "企业餐厅", value: 9 },
  { label: "其他", value: 10},
];

/** 餐饮店类别 */
export const RestaurantTypeEnum = [
  { label: "重点区域", value: 1 },
  { label: "内部食堂", value: 2 },
  { label: "沿街商铺", value: 3 },
  { label: "商住一体", value: 4 },
  { label: "其他", value: 5 },
];

/** 是否（是/否） */
export const YesNoEnum = [
  { label: "是", value: 1 },
  { label: "否", value: 2 },
];

/** 有/无 */
export const HasNotEnum = [
  { label: "有", value: 1 },
  { label: "无", value: 2 },
];
export const CityEnum = [{ label: "漯河市", value: 411100 }];
export const DistrictEnum = [ 
  { label: "源汇区", value:411102 },
  { label: "郾城区", value: 411103 },
  { label: "召陵区", value: 411104 },
  { label: "舞阳县", value: 411121 },
  { label: "临颍县", value: 411122 },
  { label: "西城区", value: 411105 },
  { label: "经开区", value: 411106 },
  { label: "示范区", value: 411107 },
];
export const getDistrictEnumByInitialState = (districtCode: number) => {
  if(districtCode == 0){
    return DistrictEnum;
  }else{
    return DistrictEnum.filter((item) => item.value == districtCode);
  }
};

/** 街道办事处 */
export const OfficeEnum = {
  411102:[],
  411103:[],
  411104:[],
  411121:[
    { label: "舞泉镇", value: 411121001 },
    { label: "吴城镇", value: 411121002 },
  ],
  411105:[],
  411106:[],
  411107:[],
  411122:[
    { label: "城关街道办事处", value: 411122001 },
    { label: "新城街道办事处", value: 411122002 }
  ]
};

export type DistrictEnumOfficeItem = {
  officeCode: number | string;
  officeName: string;
};

export type DistrictEnumDistrictItem = {
  districtCode: number | string;
  district: string;
  children?: DistrictEnumOfficeItem[];
};

export type DistrictEnumCityItem = {
  cityCode: number | string;
  city: string;
  children?: DistrictEnumDistrictItem[];
};

export type DistrictEnumProvinceItem = {
  provinceCode?: number | string;
  province?: string;
  children?: DistrictEnumCityItem[];
};

export type DistrictSelectOption = {
  label: string;
  value: number;
};

/** 将 districtEnum 树形数据扁平化为「省-市-区」下拉选项 */
export const buildDistrictSelectOptions = (
  districtEnum?: DistrictEnumProvinceItem[],
): DistrictSelectOption[] => {
  const options: DistrictSelectOption[] = [];

  (Array.isArray(districtEnum) ? districtEnum : []).forEach((province) => {
    const provinceName = province.province || '';
    (province.children || []).forEach((city) => {
      const cityName = city.city || '';
      (city.children || []).forEach((district) => {
        const districtCode = Number(district.districtCode);
        if (Number.isNaN(districtCode)) return;
        const districtName = district.district || '';
        options.push({
          label: `${provinceName}-${cityName}-${districtName}`,
          value: districtCode,
        });
      });
    });
  });

  return options;
};

type TranslateDistrictEnumParams = {
  districtEnum?: DistrictEnumProvinceItem[];
  cityCode?: DistrictCodeValue;
  districtCode?: DistrictCodeValue;
  officeCodes?: DistrictCodeValue;
  emptyText?: string;
};

export type DistrictCodeValue = Array<number | string> | number | string | null | undefined;

type DistrictEnumNameParams = {
  districtEnum?: DistrictEnumProvinceItem[];
  emptyText?: string;
};

const toCodeText = (value: unknown) => {
  if (value === undefined || value === null || value === '') return '';
  return String(value);
};

const toCodeList = (value: DistrictCodeValue) => {
  if (Array.isArray(value)) return value.map(toCodeText).filter(Boolean);
  if (typeof value === 'string' && value.includes(',')) {
    return value.split(',').map((item) => item.trim()).filter(Boolean);
  }
  const code = toCodeText(value);
  return code ? [code] : [];
};

/** 只根据城市编码翻译城市名称，支持数组或逗号分隔的多个编码 */
export const getCityNamesByCodes = ({
  districtEnum,
  cityCodes,
  emptyText = '-',
}: DistrictEnumNameParams & { cityCodes?: DistrictCodeValue }) => {
  const cityCodeList = toCodeList(cityCodes);
  if (!cityCodeList.length) return emptyText;

  const cityMap = new Map<string, string>();
  (Array.isArray(districtEnum) ? districtEnum : []).forEach((province) => {
    (province.children || []).forEach((city) => {
      cityMap.set(toCodeText(city.cityCode), city.city);
    });
  });

  return cityCodeList.map((code) => cityMap.get(code) || code).join('、');
};

/** 只根据区县编码翻译区县名称，支持数组或逗号分隔的多个编码 */
export const getDistrictNamesByCodes = ({
  districtEnum,
  districtCodes,
  emptyText = '-',
}: DistrictEnumNameParams & { districtCodes?: DistrictCodeValue }) => {
  const districtCodeList = toCodeList(districtCodes);
  if (!districtCodeList.length) return emptyText;

  const districtMap = new Map<string, string>();
  (Array.isArray(districtEnum) ? districtEnum : []).forEach((province) => {
    (province.children || []).forEach((city) => {
      (city.children || []).forEach((district) => {
        districtMap.set(toCodeText(district.districtCode), district.district);
      });
    });
  });

  return districtCodeList.map((code) => districtMap.get(code) || code).join('、');
};

/** 只根据街道/办事处编码翻译名称，支持数组或逗号分隔的多个编码 */
export const getOfficeNamesByCodes = ({
  districtEnum,
  officeCodes,
  emptyText = '-',
}: DistrictEnumNameParams & { officeCodes?: DistrictCodeValue }) => {
  const officeCodeList = toCodeList(officeCodes);
  if (!officeCodeList.length) return emptyText;

  const officeMap = new Map<string, string>();
  (Array.isArray(districtEnum) ? districtEnum : []).forEach((province) => {
    (province.children || []).forEach((city) => {
      (city.children || []).forEach((district) => {
        (district.children || []).forEach((office) => {
          officeMap.set(toCodeText(office.officeCode), office.officeName);
        });
      });
    });
  });
  Object.values(OfficeEnum).forEach((offices) => {
    offices.forEach((office) => {
      const officeCode = toCodeText(office.value);
      if (!officeMap.has(officeCode)) {
        officeMap.set(officeCode, office.label);
      }
    });
  });

  return officeCodeList.map((code) => officeMap.get(code) || code).join('、');
};

/** 根据 initialState.currentUser.districtEnum 翻译城市、区县、街道编码 */
export const translateDistrictEnum = ({
  districtEnum,
  cityCode,
  districtCode,
  officeCodes,
  emptyText = '-',
}: TranslateDistrictEnumParams) => {
  return {
    cityText: getCityNamesByCodes({ districtEnum, cityCodes: cityCode, emptyText }),
    districtText: getDistrictNamesByCodes({ districtEnum, districtCodes: districtCode, emptyText }),
    officeText: getOfficeNamesByCodes({ districtEnum, officeCodes, emptyText }),
  };
};

/** 根据状态值取文案 */
export const getStatusText = (status: number) =>
  RestaurantStatusEnum.find((e) => e.value == status)?.label ?? "-";

/** 根据规模值取文案 */
export const getScaleText = (scale: number) =>
  RestaurantScaleEnum.find((e) => e.value == scale)?.label ?? "-";

/** 根据区代码取区名 */
export const getDistrictName = (district: number) =>{
  return DistrictEnum.find((e) => e.value == district)?.label ?? "-";
}
  ;

/** 根据品类值取文案 */
export const getCategoryText = (category: number) =>
  RestaurantCategoryEnum.find((e) => e.value == category)?.label ?? "-";

/** 根据类别值取文案 */
export const getTypeText = (type: number) =>
  RestaurantTypeEnum.find((e) => e.value == type)?.label ?? "-";


/** 根据是否值取文案 */
export const getYesNoText = (yesNo: number) =>
  YesNoEnum.find((e) => e.value == yesNo)?.label ?? "-";

/** 根据有/无值取文案 */
export const getHasNotText = (hasNot: number) =>
  HasNotEnum.find((e) => e.value == hasNot)?.label ?? "-";

export const getOfficeText = (districtCode: number, officeCode: number) =>
  OfficeEnum[districtCode as keyof typeof OfficeEnum].find((e) => e.value == officeCode)?.label ?? "-";
/** 审批状态枚举 */
export const AuditStatusEnum = [
  { label: "待审批", value: 0 },
  { label: "通过", value: 1 },
  { label: "拒绝", value: 2 },
];
export const AccountTypeEnum = [
  { label: '系统管理员', value: 31 },
  { label: '巡查员', value: 32 },
  { label: '监测员', value: 33 },
];

export const BikeAccountTypeEnum = [
  { label: '单车系统管理员', value: 34 },
  { label: '单车巡查员', value: 35 },
];
/** 根据审批状态值取文案 */
export const getAuditStatusText = (status: number) =>
  AuditStatusEnum.find((e) => e.value == status)?.label ?? "-";
